import { Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ICampaignForm } from '@campaign-form/campaign-form.interface';
import { TranslateModule } from '@ngx-translate/core';
import { MatErrorComponent } from '@shared/components/mat-error/mat-error.component';
import { QuillModule } from 'ngx-quill';

@Component({
  imports: [QuillModule, MatErrorComponent, TranslateModule, ReactiveFormsModule, MatFormFieldModule],
  selector: 'app-campaign-notes',
  templateUrl: './campaign-notes.component.html',
})
export class CampaignNotesComponent {
  public readonly form = input.required<FormGroup<ICampaignForm>>();
}
